import { ChatDatabase } from './schema';

export const db = new ChatDatabase();

export * from './types';
export { ChatDatabase } from './schema';
